app.factory("SudoUtilsService", ["$http",
    function ($http) {
        var SudoUtilsService = {};

        SudoUtilsService.recalculateSemesterCredits = function () {
            return $http.get("/sudo-utils/recalculate-semester-credits").then(function (resp) {
                return resp.data;
            });
        };

        SudoUtilsService.getGradesExportList = function (params) {
            return $http.get("/sudo-utils/list-grade-exports", {params: params}).then(function (resp) {
                return resp.data;
            });
        };

        SudoUtilsService.addGradesExport = function (params) {
            return $http.post("/sudo-utils/add-grades-export", params).then(function (resp) {
                return resp.data;
            });
        };

        SudoUtilsService.closeSelections = function () {
            return $http.post("/sudo-utils/close-selections").then(function (resp) {
                return resp.data;
            });
        };

        SudoUtilsService.incrementSemesters = function () {
            return $http.post("/sudo-utils/increment-semesters").then(function (resp) {
                return resp.data;
            });
        };

        return SudoUtilsService;
    }
]);
